// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1535":"df93ae32","5899":"31d6cfe0","7087":"099866cd","7655":"4bdd9d72"}[chunkId] + ".chunk.css";
};